<div class="container-fluid px-0">
  <div class="d-flex min-vh-100">
    <!-- Side Nav -->
    <app-side-nav></app-side-nav>

    <!-- Main Content -->
    <main class="flex-grow-1">
      <div class="container-fluid px-3 py-2">
        <!-- Header Section -->
        <div class="row align-items-center py-3 mb-4">
          <div class="col-md-6">
            <h4 class="study-heading mb-0">
              <span class="text-muted fw-light">Study Management /</span> Build eCRF
            </h4>
          </div>
          <div class="col-md-6 text-md-end">
            <button type="button" class="btn custom-button" (click)="openCreateTemplateModal()">
              Create New
            </button>
          </div>
        </div>

        <!-- Search and Filters Section -->
        <div class="row g-2 mb-3">
          <div class="col-12 col-lg-3">
            <p class="template-hint mb-0">
              Select/Create eCRF template for the study
            </p>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <input type="text" class="form-control filter-input" placeholder="Search by Template Name" [(ngModel)]="search2" />
          </div>
          <div class="col-12 col-sm-6 col-lg-2">
            <input type="text" class="form-control filter-input" placeholder="Search by Created By" [(ngModel)]="search3" />
          </div>
          <div class="col-12 col-sm-6 col-lg-2">
            <select class="form-select cursor-pointer filter-input" [(ngModel)]="lockFilter">
              <option value="" disabled selected hidden>Filter By Lock Status</option>
              <option value="locked">Locked</option>
              <option value="unlocked">Unlocked</option>
            </select>
          </div>
          <div class="col-12 col-sm-6 col-lg-2">
            <div class="d-grid gap-2 d-md-flex">
              <button class="btn custom-button flex-fill" (click)="searchUsers()">
                Search
              </button>
              <button class="btn custom-button flex-fill" (click)="clear()">Clear</button>
            </div>
          </div>
        </div>

        <!-- Spinner -->
        <div *ngIf="loading" class="row justify-content-center align-items-center" style="height: 150px">
          <div class="col-auto">
            <div class="spinner-border text-purple" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>

        <!-- Table Section -->
        <div class="row" *ngIf="!loading">
          <div class="col-12">
            <div class="card mt-2">
              <div class="table-responsive rounded">
                <table class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th>Template Number</th>
                      <th>Template Name</th>
                      <th>Created By</th>
                      <th>Created On</th>
                      <th class="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody class="table-border-bottom-0">
                    <tr *ngFor="let template of filteredTemplates; let i = index">
                      <td>{{ template.template_number || i + 1 }}</td>
                      <td [class.text-muted]="template.is_locked" 
                          [class.pointer-cursor]="!template.is_locked"
                          (click)="template.is_locked ? null : openEditModal(template)">
                        {{ template.name }}
                        <span *ngIf="template.is_locked" class="badge bg-warning ms-2">🔒 Locked</span>
                        <span *ngIf="template.is_duplicate" class="badge bg-info ms-2">📋 Duplicate</span>
                      </td>
                      <td>{{ template.created_by }}</td>
                      <td>{{ template.created_on }}</td>
                      <td class="text-center">
                        <div class="dropdown" data-bs-display="static">
                          <button type="button" class="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                            <i class="bx bx-dots-vertical-rounded"></i>
                          </button>
                          <div class="dropdown-menu dropdown-menu-end custom-dropdown-menu">
                            <a class="dropdown-item" href="javascript:void(0);" (click)="openEditModal(template)" *ngIf="!template.is_locked">
                              <i class="bx bx-edit-alt me-1"></i>Edit
                            </a>
                            <a class="dropdown-item" href="javascript:void(0);" (click)="lockTemplate(template)" *ngIf="!template.is_locked">
                              <i class="bx bx-lock"></i> Lock
                            </a>
                            <a class="dropdown-item" href="javascript:void(0);" (click)="duplicateTemplate(template)" *ngIf="template.is_locked">
                              <i class="bx bx-copy me-1"></i>Duplicate Template
                            </a>
                            <a class="dropdown-item" href="javascript:void(0);" (click)="renameTemplate(template)" *ngIf="template.is_duplicate">
                              <i class="bx bx-edit me-1"></i>Rename
                            </a>
                            <a class="dropdown-item" href="javascript:void(0);" (click)="deleteTemplate(template.id)">
                              <i class="bx bx-trash me-1"></i>Delete
                            </a>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Pagination Section -->
        <div class="row justify-content-center mt-4">
          <div class="col-auto">
            <nav aria-label="Page navigation">
              <ul class="pagination mb-0">
                <li class="page-item mx-2" [class.disabled]="currentPage === 1">
                  <a class="page-link" href="javascript:void(0);" (click)="prevPage()">Previous</a>
                </li>
                <li *ngFor="let page of pageRange" class="page-item mx-2" [class.active]="page === currentPage">
                  <a class="page-link" href="javascript:void(0);" (click)="goToPage(page)">{{ page }}</a>
                </li>
                <li class="page-item" [class.disabled]="currentPage === pages">
                  <a class="page-link" href="javascript:void(0);" (click)="nextPage()">Next</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </main>
  </div>

  <!-- Modals Section -->
  
  <!-- Create Template Modal -->
  <div class="modal" *ngIf="showCreateTemplateModal" (click)="closeCreateTemplateModal()">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <div class="modal-content p-4">
        <h5 class="modal-title">Create New Template</h5>
        <div class="mb-3">
          <label class="form-label">Template Name:</label>
          <input type="text" class="form-control" [(ngModel)]="newTemplateName" 
                 placeholder="Enter template name" (keyup.enter)="createTemplate()" />
          <div *ngIf="templateNameError" class="text-danger mt-1">
            {{ templateNameError }}
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn custom-button me-2" (click)="closeCreateTemplateModal()">
            Cancel
          </button>
          <button class="btn custom-button" (click)="createTemplate()" [disabled]="!newTemplateName.trim()">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Duplicate Template Modal -->
  <div class="modal" *ngIf="showDuplicateModal" (click)="closeDuplicateModal()">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <div class="modal-content p-4">
        <h5 class="modal-title">Duplicate Template</h5>
        <div class="mb-3">
          <p class="text-muted">
            Template "<strong>{{ templateToDuplicate?.name }}</strong>" will be duplicated with all its folders, forms, and fields.
          </p>
        </div>
        <div class="mb-3">
          <label class="form-label">New Template Name:</label>
          <input type="text" class="form-control" [(ngModel)]="duplicateTemplateName" 
                 placeholder="Enter new template name" (keyup.enter)="confirmDuplicateTemplate()" />
          <div *ngIf="duplicateTemplateNameError" class="text-danger mt-1">
            {{ duplicateTemplateNameError }}
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn custom-button me-2" (click)="closeDuplicateModal()">
            Cancel
          </button>
          <button class="btn custom-button" (click)="confirmDuplicateTemplate()" 
                  [disabled]="!duplicateTemplateName.trim() || duplicating">
            <span *ngIf="!duplicating">Duplicate</span>
            <span *ngIf="duplicating">
              <i class="bx bx-loader-alt bx-spin me-1"></i>Duplicating...
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Rename Template Modal -->
  <div class="modal" *ngIf="showRenameModal" (click)="closeRenameModal()">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <div class="modal-content p-4">
        <h5 class="modal-title">Rename Template</h5>
        <div class="mb-3">
          <label class="form-label">New Template Name:</label>
          <input type="text" class="form-control" [(ngModel)]="renameTemplateName" 
                 placeholder="Enter new template name" (keyup.enter)="confirmRenameTemplate()" />
          <div *ngIf="renameTemplateNameError" class="text-danger mt-1">
            {{ renameTemplateNameError }}
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn custom-button me-2" (click)="closeRenameModal()">
            Cancel
          </button>
          <button class="btn custom-button" (click)="confirmRenameTemplate()" 
                  [disabled]="!renameTemplateName.trim() || renaming">
            <span *ngIf="!renaming">Rename</span>
            <span *ngIf="renaming">
              <i class="bx bx-loader-alt bx-spin me-1"></i>Renaming...
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Lock/Unlock Template Modal -->
  <div class="modal" *ngIf="showLockModal" (click)="closeLockModal()">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <div class="modal-content p-4">
        <h5 class="modal-title">Lock Template</h5>
        <div class="mb-3">
          <label class="form-label">Email:</label>
          <input type="email" class="form-control" [(ngModel)]="lockEmail" 
                 placeholder="Enter your email" (keyup.enter)="authenticateAndLock()" />
        </div>
        <div class="mb-3">
          <label class="form-label">Password:</label>
          <div class="input-group">
            <input [type]="showLockPassword ? 'text' : 'password'" class="form-control" 
                   [(ngModel)]="lockPassword" placeholder="Enter your password" 
                   (keyup.enter)="authenticateAndLock()" />
            <button class="btn btn-outline-secondary" type="button" (click)="toggleLockPasswordVisibility()">
              <i class="bx" [class.bx-show]="!showLockPassword" [class.bx-hide]="showLockPassword"></i>
            </button>
          </div>
        </div>
        <div *ngIf="lockError" class="text-danger mb-3">
          {{ lockError }}
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn custom-button me-2" (click)="closeLockModal()">
            Cancel
          </button>
          <button class="btn custom-button" (click)="authenticateAndLock()" [disabled]="!lockEmail || !lockPassword">
            Lock
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Terms and Conditions Modal -->
  <div class="modal" *ngIf="showTermsModal" (click)="closeTermsModal()">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <div class="modal-content p-4">
        <h5 class="modal-title">Template Locking - Terms and Conditions</h5>
        <div class="mb-3">
          <div class="alert alert-warning">
            <h6><strong>Important Warnings:</strong></h6>
            <ul class="mb-0">
              <li>Once locked, this template <strong>CANNOT be unlocked.</strong></li>
              <li>You will <strong>NOT be able to edit</strong> the template structure, folders, forms, or fields.</li>
              <li>Only <strong>duplication</strong> will be allowed for locked templates.</li>
              <li>This action is <strong>IRREVERSIBLE.</strong></li>
              <li>Make sure the template is <strong>complete and finalized</strong> before locking.</li>
            </ul>
          </div>
        </div>
        <div class="mb-3">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="termsCheckbox" [(ngModel)]="termsAccepted" />
            <label class="form-check-label" for="termsCheckbox">
              <strong>I understand and accept the above terms and conditions</strong>
            </label>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn custom-button me-2" (click)="closeTermsModal()">
            Cancel
          </button>
          <button class="btn custom-button" (click)="acceptTerms()" [disabled]="!termsAccepted">
            Accept & Continue
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Final Confirmation Modal -->
  <div class="modal" *ngIf="showConfirmModal" (click)="closeConfirmModal()">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <div class="modal-content p-4">
        <h5 class="modal-title">Final Confirmation</h5>
        <div class="mb-3">
          <div class="alert alert-danger">
            <h6><strong>Are you sure you want to lock this template?</strong></h6>
            <p class="mb-2"><strong>Template:</strong> {{ currentTemplate?.name }}</p>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn custom-button me-2" (click)="closeConfirmModal()">
            No, Cancel
          </button>
          <button class="btn btn-danger" (click)="confirmLock()">
            Yes, Lock Template
          </button>
        </div>
      </div>
    </div>
  </div>
</div>